import axiosInstance from "../Utils/axiosInstance";
import { FilesApi } from "../Constants/api";

export const getFilesApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${FilesApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
